// Services
import apiClient from '@/services/AccountClient'

export default {
  fetchById (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/profile-customers/${id}`
    )
  },
  update (id, data) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/profile-customers/${id}`,
      data
    )
  },
  fetchFeeGroups (customerId) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/profile-customers/${customerId}/fees/groups`
    )
  },
  addAccountNumber (id, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/profile-customers/${id}/account-number`,
      data
    )
  },
  setAccountNumberStatus (id, { accountNumber, status }) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/profile-customers/${id}/account-number/${accountNumber}/status`,
      { status }
    )
  }
}
